module.exports = __webpack_public_path__ + "img/xhl-wang.a5311653.png";